import { BAPIError } from "@/bapi-client/errors";
import { fetchHandler } from "@/bapi-client/fetch";
import { Result } from "@/bapi-client/types";
import { BAPI_COMMANDS } from "@/bapi-client/types/commands";
import { BulkUserUploadResponse } from "@/bapi-client/types/internal_tools";
import { UserCondensed, UserExtended, UserRequestBody, UserRole } from "@/bapi-client/types/user";

export async function adminGetUser(userId: string): Promise<Result<UserExtended>> {
  const response = await fetchHandler(BAPI_COMMANDS.ADMIN_GET_USER, "GET", `/admin/users/${userId}`);
  if (!response.success) {
    return { success: response.success, error: new BAPIError("Failed to load user", response.error.status) };
  }

  const userJson = await response.data.json();
  return userJson;
}

export async function adminGetUsers(): Promise<Result<UserCondensed[]>> {
  const response = await fetchHandler(BAPI_COMMANDS.ADMIN_GET_USERS, "GET", "/admin/users");
  if (!response.success) return response;
  const parsed = await response.data.json();
  return parsed.success ? { success: parsed.success, data: parsed.data.users } : parsed;
}

export async function adminDeleteUser(userId: string): Promise<Result<UserExtended>> {
  const response = await fetchHandler(BAPI_COMMANDS.ADMIN_DELETE_USER, "DELETE", `/admin/users/${userId}`);
  if (!response.success) return response;
  return await response.data.json();
}

export async function adminUpdateUser(userId: string, formData: UserRequestBody): Promise<Result<UserExtended>> {
  const response = await fetchHandler(BAPI_COMMANDS.ADMIN_UPDATE_USER, "PUT", `/admin/users/${userId}`, {
    body: formData,
  });
  return !response.success ? response : await response.data.json();
}

export async function adminCreateUser(formData: UserRequestBody): Promise<Result<UserExtended>> {
  const response = await fetchHandler(BAPI_COMMANDS.ADMIN_CREATE_USER, "POST", "/admin/users", {
    body: formData,
  });
  if (!response.success) return response;
  const parsed = await response.data.json();
  return parsed.success ? { success: true, data: parsed.data.user } : parsed;
}

export async function adminBulkUploadUsers(formData: FormData): Promise<Result<BulkUserUploadResponse>> {
  const response = await fetchHandler(BAPI_COMMANDS.ADMIN_BULK_USER_UPLOAD, "POST", "/admin/users/bulk_upload", {
    body: formData,
  });
  if (!response.success) return response;
  const parsed = await response.data.json();
  return parsed.success ? { success: true, data: parsed.data } : parsed;
}

export async function adminGetUserRoles(): Promise<Result<UserRole[]>> {
  const response = await fetchHandler(BAPI_COMMANDS.ADMIN_GET_USER_ROLES, "GET", "/admin/users/roles");
  if (!response.success) return response;
  const parsed = await response.data.json();
  return parsed.success ? { success: true, data: parsed.data.roles } : parsed;
}
